module.exports = __webpack_public_path__ + "static/img/des.686ce357.webp";